import * as React from 'react';
import { RadioChipButton } from '../RadioChipButton';
import { ChipsGroup } from '../../../internal/components/Chip';
import { useId } from '../../../internal/hooks';
import { useRadioGroupOptions } from '../../../checkbox/internal';

/**
 * @deprecated использовать компонент Chips с пропсом selectType=oneOf
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const RadioChipsGroup = /*#__PURE__*/React.memo(function RadioChipsGroup(props) {
  const {
    defaultValue,
    disabled,
    invalid,
    role,
    inline,
    size,
    title,
    titleWeight,
    fullWidth,
    iconPosition,
    counterMaxLength,
    scrollable
  } = props;
  const options = useRadioGroupOptions(props);
  const name = useId(props.name);
  return /*#__PURE__*/_jsx(ChipsGroup, {
    title: title,
    size: size,
    titleWeight: titleWeight,
    role: role,
    inline: inline,
    fullWidth: fullWidth,
    scrollable: scrollable,
    children: options.map(_ref => {
      let {
        value,
        label,
        onChange,
        icon,
        counter,
        checked
      } = _ref;
      const key = String(value);
      return /*#__PURE__*/_jsx(RadioChipButton, {
        // Приводится к строке, чтобы не ослаблять типы
        name: name,
        value: key,
        checked: checked,
        defaultChecked: defaultValue !== undefined ? defaultValue === value : undefined,
        disabled: disabled,
        invalid: invalid,
        label: label,
        onChange: onChange,
        role: role === 'listbox' ? 'option' : undefined,
        size: size,
        counterMaxLength: counterMaxLength,
        iconPosition: iconPosition,
        icon: icon,
        counter: counter,
        scrollInView: scrollable
      }, key);
    })
  });
});